export const IntakeStatus = {
  New: 'New Intake',
  Waiting: 'Awaiting Intake',
  IntakeInProgress: 'Intake in Progress',
  Completed: 'Completed',
  AdmissionInProgress: 'Admission in Progress',
  NotAdmitted: 'Not Admitted',
  Admitted: 'Admitted',
  Cancel: 'Canceled'
}

export const IntakeStages = {
  Referral: 'Referral',
  Payment: 'Payment',
  Physician: 'Physician',
  Eligibility: 'Eligibility Check',
  InitialOrder: 'Initial Order'
}

export const AdmissionStages = {
  Admission: 'Admission',
  Order: 'Order',
  Physician: 'Physician',
  Episode: 'Episode'
}
